// Taxonomies
export const GET_SCHOOLS_TYPES = 'GET_SCHOOLS_TYPES';
export const GET_SCHOOLS_PROGRAMMES = 'GET_SCHOOLS_PROGRAMMES';
export const GET_SCHOOLS_CERTIFICATIONS = 'GET_SCHOOLS_CERTIFICATIONS';
export const GET_SCHOOLS_DEGREES = 'GET_SCHOOLS_DEGREES';
export const TAXONOMIES_LOADING = 'TAXONOMIES_LOADING';

// Schools list for the dropdown
export const GET_SCHOOLS_DROPDOWN_REQUEST = 'GET_SCHOOLS_DROPDOWN_REQUEST';
export const GET_SCHOOLS_DROPDOWN_FAILURE = 'GET_SCHOOLS_DROPDOWN_FAILURE';
export const GET_SCHOOLS_DROPDOWN_SUCCESS = 'GET_SCHOOLS_DROPDOWN_SUCCESS';

// Schools list for the Google Maps
export const GET_SCHOOLS_MAPS_REQUEST = 'GET_SCHOOLS_MAPS_REQUEST';
export const GET_SCHOOLS_MAPS_FAILURE = 'GET_SCHOOLS_MAPS_FAILURE';
export const GET_SCHOOLS_MAPS_SUCCESS = 'GET_SCHOOLS_MAPS_SUCCESS';

// School details
export const GET_SCHOOL_REQUEST = 'GET_SCHOOL_REQUEST';
export const GET_SCHOOL_FAILURE = 'GET_SCHOOL_FAILURE';
export const GET_SCHOOL_SUCCESS = 'GET_SCHOOL_SUCCESS';

// Schools list
export const GET_SCHOOLS_REQUEST = 'GET_SCHOOLS_REQUEST';
export const GET_SCHOOLS_FAILURE = 'GET_SCHOOLS_FAILURE';
export const GET_SCHOOLS_SUCCESS = 'GET_SCHOOLS_SUCCESS';
export const SET_SCHOOLS_SEARCH_CRITERIA = 'SET_SCHOOLS_SEARCH_CRITERIA';
export const RESET_SCHOOLS_SEARCH_CRITERIA = 'RESET_SCHOOLS_SEARCH_CRITERIA';
export const TOGGLE_DRAWER_MOBILE_FILTER_SEARCH = 'TOGGLE_DRAWER_MOBILE_FILTER_SEARCH';

// Dashboard
export const DASHBOARD_GET_SCHOOLS_AUTHOR = 'DASHBOARD_GET_SCHOOLS_AUTHOR';
export const DASHBOARD_GET_SCHOOLS_LOADING = 'DASHBOARD_GET_SCHOOLS_LOADING';

// UI
export const UI_SET_SCHOOL_FOCUSED = 'UI_SET_SCHOOL_FOCUSED';
export const UI_REMEMBER_SCROLL_POSITION_LISTING = 'UI_REMEMBER_SCROLL_POSITION_LISTING';
export const UI_REMEMBER_PAGINATION_LISTING = 'UI_REMEMBER_PAGINATION_LISTING';



// WEBPACK FOOTER //
// ./src/features/Schools/types.js